import { EditableActivity } from "@ac-expo/api-types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { activitiesQueryKeys } from "../query-keys/activities.query-keys";

const getActivities = async (
  eventId: string,
  optionnalParams?: {
    searchText: string;
    startDate: string;
    endDate: string;
  },
) => {
  const { data } = await privateAxios.get<EditableActivity[]>("/activities/event", {
    params: {
      eventId,
      ...optionnalParams,
    },
  });
  return data;
};

export const useGetActivitiesQuery = (
  eventId: string,
  optionnalParams?: {
    searchText: string;
    startDate: string;
    endDate: string;
  },
) => {
  return useQuery({
    queryKey: [...activitiesQueryKeys.event(eventId), optionnalParams],
    queryFn: () => getActivities(eventId, optionnalParams),
    enabled: !!eventId,
  });
};

const getActivity = async (activityId: string) => {
  const { data } = await privateAxios.get<EditableActivity>(`/activities/${activityId}`);
  return data;
};

export const useGetActivityQuery = (activityId: string) => {
  return useQuery({
    queryKey: activitiesQueryKeys.get(activityId),
    queryFn: () => getActivity(activityId),
  });
};

const getStructureActivities = async (eventId: string, structureId: string) => {
  const { data } = await privateAxios.get<EditableActivity[]>(
    `/activities/structure/${structureId}/event/${eventId}`,
  );
  return data;
};

export const useGetStructureActivitiesQuery = (eventId: string, structureId: string) => {
  return useQuery({
    queryKey: activitiesQueryKeys.event(eventId, structureId),
    queryFn: () => getStructureActivities(eventId, structureId),
  });
};
